import styled from 'styled-components';
import { Box } from '@mantine/core';

export const DropZoneBox = styled(Box)`
  border: ${props =>
    props.borderless ? 'none' : props.isDragActive ? '2px dashed #2f6fe4' : '1px solid #d8dee8'};
  border-radius: 10px;
  padding: ${props => (props.variant === 'compact' ? '8px 12px' : '12px 16px')};
  text-align: center;
  background-color: ${props =>
    props.borderless ? 'transparent' : props.isDragActive ? '#eaf1ff' : '#f8fafd'};
  opacity: ${props => (props.disabled ? 0.55 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  transition:
    border-color 0.18s ease,
    background-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;
  cursor: pointer;
  min-height: ${props => (props.variant === 'compact' ? '40px' : '56px')};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:focus-within {
    outline: none;
    box-shadow: 0 0 0 3px rgba(47, 111, 228, 0.22);
  }

  &:hover {
    border-color: #9db7ea;
    background-color: #f2f6ff;
  }

  &.active {
    border-color: #2f6fe4;
    background-color: #eaf1ff;
    box-shadow: 0 8px 22px rgba(47, 111, 228, 0.18);
    transform: translateY(-1px);
  }
`;
